<div class="search-message">{{ "home.redirect.message" | translate: { searchText: searchInPub } }}</div>

@for (product of products | async | groupProducts; track product._id) {
  <o-card-pub-container [lastRev]="product.lastRev" [oldRevs]="product.oldRevs" [searchInPub]="searchInPub">
  </o-card-pub-container>
}
